/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { TasksApiConfiguration as __Configuration } from '../tasks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultTaskEventInfo } from '../models/list-query-result-task-event-info';
@Injectable({
  providedIn: 'root',
})
class TaskEventService extends __BaseService {
  static readonly GetTaskEventsPath = '/api/tasks/tasks/{id}/events';
  static readonly GetAllPath = '/api/tasks/tasks/events';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetTaskEventsResponse(id: string): __Observable<__StrictHttpResponse<ListQueryResultTaskEventInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/tasks/${id}/events`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTaskEventInfo>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetTaskEvents(id: string): __Observable<ListQueryResultTaskEventInfo> {
    return this.GetTaskEventsResponse(id).pipe(
      __map(_r => _r.body as ListQueryResultTaskEventInfo)
    );
  }

  /**
   * @param params The `TaskEventService.GetAllParams` containing the following parameters:
   *
   * - `tasks`:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `raisedOnTo`:
   *
   * - `raisedOnFrom`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAllResponse(params: TaskEventService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultTaskEventInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.tasks || []).forEach(val => {if (val != null) __params = __params.append('tasks', val.toString())});
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.raisedOnTo != null) __params = __params.set('raisedOnTo', params.raisedOnTo.toString());
    if (params.raisedOnFrom != null) __params = __params.set('raisedOnFrom', params.raisedOnFrom.toString());
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/tasks/events`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTaskEventInfo>;
      })
    );
  }
  /**
   * @param params The `TaskEventService.GetAllParams` containing the following parameters:
   *
   * - `tasks`:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `raisedOnTo`:
   *
   * - `raisedOnFrom`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAll(params: TaskEventService.GetAllParams): __Observable<ListQueryResultTaskEventInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultTaskEventInfo)
    );
  }
}

module TaskEventService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    tasks?: Array<string>;
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    raisedOnTo?: string;
    raisedOnFrom?: string;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
  }
}

export { TaskEventService }
